<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <domains-table />
      </div>
    </div>
  </div>
</template>

<script>
import DomainsTable from "./components/DomainsTable.vue";

export default {
  name: "tables",
  components: {
    DomainsTable,
  },
  data() {
    return {
    };
  },
};
</script>
